// Constants used for translation services

export const LOCALE_ENGLISH = 'en';
export const LOCALE_SPANISH = 'es';
